var $db3723c51a085311$exports = {};
$db3723c51a085311$exports = {
  "backButton": args => "Volver a ".concat(args.prevMenuButton),
  "moreActions": "M\xE1s acciones",
  "unavailable": "No disponible, ampliar para m\xE1s detalles"
};
export { $db3723c51a085311$exports as default };